import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/mob/designs`;


const getAllSections = async (params) => {
    return await axiosGet(`${BASE_URL}/home/section`, { ...params });
}
const createSection = async (params) => {
    return await axiosPost(`${BASE_URL}/home/create`, { ...params });
}
const updateSection = async (params) => {
    return await axiosPost(`${BASE_URL}/home/update`, { ...params });
}
const deleteSection = async (id) => {
    return await axiosPost(`${BASE_URL}/home/section/delete`, { id });
}
const updateListStatus = async (params) => {
    return await axiosPost(`${BASE_URL}/home/section/update/list/status`, { ...params });
}
const updateItem = async (params) => {
    return await axiosPostWithFile(`${BASE_URL}/home/section/update/single`, params);
}
const updateSectionData = async (params) => {
    return await axiosPostWithFile(`${BASE_URL}/home/section/update/section`, params);
}
const createItem = async (params) => {
    return await axiosPostWithFile(`${BASE_URL}/home/data/create`, params);
}
const createRow = async (params) => {
    return await axiosPost(`${BASE_URL}/home/row/create`, { ...params });
}

const mobSectionApi = {
    getAllSections,
    createSection,
    updateSection,
    deleteSection,
    updateItem,
    createItem,
    updateListStatus,
    updateSectionData,
    createRow
}

export default mobSectionApi;
